export default "__VITE_ASSET__C3ki6vvs__"